export default __webpack_public_path__ + "static/media/top.5c195d22.png";